'use client';

import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import { Disclaimer } from '@/blocks/components/Disclaimer';
import { MT5Link } from '@/blocks/components/MT5OfferingModal/Modal';
import { HeroCta, HeroSection, HeroSideImage } from '@/blocks/sections/Hero';
import { MT5_VIA_PXBT } from '@/global/public-settings';
import { EventBlockNames } from '@/providers/analytics/types';

import { Device, heroImages } from '../data';

export const MTHeroSection = () => {
  const device = useParams().device as Device;
  const tr = useTranslations('pages.cfdMetaTrader');

  return (
    <HeroSection
      withHeaderSecondNavRow
      title={tr.rich(`${device}.sections.hero.title`)}
      subtitle={tr.rich(`${device}.sections.hero.subheading`)}
      actionsSlot={
        <>
          <HeroCta
            Component={MT5Link}
            platform={'web'}
            eventLabel={'open_account'}
            blockName={EventBlockNames.hero}
          >
            {tr.rich('sections.hero.actionButton')}
          </HeroCta>
          {MT5_VIA_PXBT ? <Disclaimer>{tr.rich('sections.hero.disclaimer')}</Disclaimer> : null}
        </>
      }
      rightSideLayout
      body={
        <HeroSideImage
          image={{ src: heroImages[device], width: 555, height: 394, alt: `Metatrader ${device}` }}
        />
      }
    />
  );
};
